<template>
  <div>
    <b-container>
      <b-form-group class="m-4">
        <b-form-group
          label-cols-sm="3"
          label="Neues Passwort"
          label-align-sm="right">
          <b-form-input id="password"
                        type="password"
                        placeholder="Min. 8 Zeichen"
                        v-model="newPassword">
          </b-form-input>
        </b-form-group>
        <b-form-group
          label-cols-sm="3"
          :label=" validation ? 'OK':'Passwort wiederholen'"
          label-align-sm="right"
        >
          <b-form-input id="confirmPassword"
                        type="password"
                        v-model="confirmPassword">
          </b-form-input>
        </b-form-group>
      </b-form-group>
<!--      <div class="m-4" v-if="changePassword">-->
<!--        <b-button class="col-12"-->
<!--                  v-if="newPassword"-->
<!--                  :disabled=" newPassword.length < 8 || newPassword !== confirmPassword"-->
<!--                  :variant="newPassword.length < 8 || newPassword !== confirmPassword ? '':'outline-success'"-->
<!--                  @click="emitPassword">-->
<!--          {{newPassword.length < 8 ? 'mindestens 8 Zeichen' : 'Speichern'}}-->
<!--        </b-button>-->
<!--      </div>-->
    </b-container>
  </div>

</template>

<script>
    export default {
        name: "password-input",
      data:()=>({
        // changePassword:false,
        newPassword:'',
        confirmPassword:''

      }),
      computed:{
          validation(){
            if(this.newPassword.length < 8){
              return false
            }
            return this.newPassword === this.confirmPassword  && this.newPassword ? this.emitPassword() : false
          },
      },
      methods:{
        emitPassword(){
          this.changePassword = !this.changePassword
          this.$emit( 'emitPassword' , this.newPassword )
          return true
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/password-input.vue